import { PERSONA_NAMES } from '../../utils';

export const getPersonaName = (n: number) => {
	const name = PERSONA_NAMES[n % PERSONA_NAMES.length];
	return name[0].toUpperCase() + name.slice(1);
};
